"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9706],{

/***/ 73838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Headers_CollectionHeaderDropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/CollectionHeaderDropdown/useCollectionClick.js



function useCollectionClick(toggleDropdown) {
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var handleCollectionClick = function(collection) {
        var ref;
        router_default().push((0,routes.getRoute)("".concat(routes.PATH.collectionCategories(collection.id)), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        /*
      if toggleDropdown !== undefined, then close header dropdown
      only for mobile usage
    */ toggleDropdown === null || toggleDropdown === void 0 ? void 0 : toggleDropdown();
    };
    return [
        handleCollectionClick
    ];
}

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/CollectionHeaderDropdown/CollectionHeaderDropdownWidget1.js





var CollectionHeaderDropdownWidget1 = function(param) {
    var _classes = param.classes, classes = _classes === void 0 ? "" : _classes, _toggleDropdown = param.toggleDropdown, toggleDropdown = _toggleDropdown === void 0 ? undefined : _toggleDropdown;
    var ref = (0,_sliced_to_array/* default */.Z)(useCollectionClick(toggleDropdown), 1), handleCollectionClick = ref[0];
    var collections = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections
        };
    }).collections;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "collection-list-container__body ".concat(classes),
        children: collections === null || collections === void 0 ? void 0 : collections.filter(function(collection) {
            return collection.id !== 0;
        }).map(function(collection, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "collection-item",
                onClick: function() {
                    return handleCollectionClick(collection);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "collection-image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "collection ".concat(index + 1),
                            src: collection.image_url || constants/* DEFAULT_COLLECTION_IMAGE */.t6[index]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "collection-name ttu",
                        children: collection.name
                    })
                ]
            }, collection.id);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/CollectionHeaderDropdown/CollectionHeaderDropdownWidget3.js





var CollectionHeaderDropdownWidget3 = function(param) {
    var toggleDropdown = param.toggleDropdown;
    var ref = (0,_sliced_to_array/* default */.Z)(useCollectionClick(toggleDropdown), 1), handleCollectionClick = ref[0];
    var ref1 = (0,react.useState)(null), accordionId = ref1[0], setAccordionId = ref1[1];
    var collections = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections
        };
    }).collections;
    var accordionHeaderClick = function(e) {
        e.stopPropagation();
        var dataId = e.target.getAttribute("data-id");
        if (+dataId === accordionId) {
            setAccordionId(null);
            return;
        } else if (+dataId) {
            setAccordionId(+dataId);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "collection-list-container__body collection-header-widget-3",
        children: (collections === null || collections === void 0 ? void 0 : collections.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "collection-accordion",
            children: collections === null || collections === void 0 ? void 0 : collections.map(function(collection) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "collection-accordion__container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between collection-accordion__header pointer",
                            "data-id": collection.id,
                            onClick: accordionHeaderClick,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 z-1",
                                    onClick: accordionHeaderClick,
                                    children: collection.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    "data-id": collection.id,
                                    style: {
                                        transform: "rotate(".concat(accordionId === collection.id ? "180deg" : "0deg", ")")
                                    },
                                    alt: "dropdown button",
                                    src: "/assets/images/down-arrow-thin.svg",
                                    className: "z-0"
                                })
                            ]
                        }),
                        accordionId === collection.id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "collection-accordion__body",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "body-list",
                                children: collection === null || collection === void 0 ? void 0 : (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.map(function(category) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "pointer body-list--item",
                                        onClick: function() {
                                            return handleCollectionClick(collection);
                                        },
                                        children: category.name
                                    }, category.id);
                                })
                            })
                        })
                    ]
                }, collection.id);
            })
        }) : null
    });
};

// EXTERNAL MODULE: ./src/assets/svgExports/UserIconDark.js
var UserIconDark = __webpack_require__(52514);
// EXTERNAL MODULE: ./src/utils/excuteLogout.js
var excuteLogout = __webpack_require__(85126);
// EXTERNAL MODULE: ./src/components/LogoutModal/index.js
var LogoutModal = __webpack_require__(21448);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
// EXTERNAL MODULE: ./src/components/InstallAppInstructionsOverlay/useInstallAppOverlayActions.tsx
var useInstallAppOverlayActions = __webpack_require__(41771);
// EXTERNAL MODULE: ./src/utils/checkIfWebview.js
var checkIfWebview = __webpack_require__(93326);
// EXTERNAL MODULE: ./src/utils/getNavList.js
var getNavList = __webpack_require__(4956);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/CollectionHeaderDropdown/index.js
















var InstallAppInstructionsOverlay = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 557).then(__webpack_require__.bind(__webpack_require__, 557));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(557)
            ];
        }
    },
    ssr: false
});
var CollectionHeaderDropdown = function(param) {
    var navItemsState = param.navItemsState, renderNavType = param.renderNavType, openCollections = param.openCollections, goBack = param.goBack, collectionListType = param.collectionListType, toggleDropdown = param.toggleDropdown, isLoginVisible = param.isLoginVisible, headerName = param.headerName;
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutConfirmation(!showLogoutConfirmation);
    };
    var ref = (0,react.useState)(false), showLogoutConfirmation = ref[0], setShowLogoutConfirmation = ref[1];
    var userLogin = (0,es/* useSelector */.v9)(function(state) {
        return {
            userLogin: state.userReducer.isLogin
        };
    }).userLogin;
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            storeCollections: state.catalogReducer.collections
        };
    }), storeData = ref1.storeData, storeCollections = ref1.storeCollections;
    var installAppFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().installAppFeatureStatus;
    var openIntallAppOverlay = (0,useInstallAppOverlayActions/* default */.Z)().openIntallAppOverlay;
    var isWebview = (0,checkIfWebview/* default */.Z)();
    (0,react.useEffect)(function() {
        if (showLogoutConfirmation) setShowLogoutConfirmation(false);
    }, [
        userLogin
    ]);
    var toggleAuthModal = function() {
        if (userLogin) {
            toggleLogoutModal();
        } else {
            var ref;
            router_default().push((0,routes.getRoute)(routes.PATH.ORDERS, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        }
    };
    var renderMobileLoginLogout = function() {
        var ref, ref1;
        if (headerName === "header14" && !isLoginVisible) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center justify-between mt3",
            onClick: toggleAuthModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIconDark/* UserIconDark */.q, {
                            color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== "#ffffff" ? "#000000" : "#ffffff",
                            width: "18",
                            height: "18"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: userLogin ? "red" : "black",
                        children: userLogin ? "Logout" : "Login"
                    })
                ]
            })
        });
    };
    var renderCollectionList = function() {
        switch(collectionListType){
            case "CollectionHeaderDropdownWidget1":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionHeaderDropdownWidget1, {
                    classes: "collection-header-widget-1",
                    toggleDropdown: toggleDropdown
                });
            case "CollectionHeaderDropdownWidget2":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionHeaderDropdownWidget1, {
                    classes: "collection-header-widget-2",
                    toggleDropdown: toggleDropdown
                });
            case "CollectionHeaderDropdownWidget3":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionHeaderDropdownWidget3, {
                    toggleDropdown: toggleDropdown
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionHeaderDropdownWidget1, {
                    classes: "collection-header-widget-1",
                    toggleDropdown: toggleDropdown
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dropdown ".concat(openCollections ? "active" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "nav-state",
                        children: (navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "dropdown--menu w-100",
                            children: [
                                navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.map(function(page) {
                                    return renderNavType(page, true);
                                }),
                                !isWebview && (installAppFeatureStatus === null || installAppFeatureStatus === void 0 ? void 0 : installAppFeatureStatus.isVisible) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "menu-item black pwa:tw-hidden",
                                    onClick: function() {
                                        openIntallAppOverlay();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Install App"
                                    })
                                }),
                                !(0,getNavList/* showMyAccount */.p6)() && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "menu-item",
                                    style: {
                                        borderTop: "1px solid #ebebeb"
                                    },
                                    children: renderMobileLoginLogout()
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "collection-list-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "collection-list-container__header",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    onClick: goBack,
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/images/down-arrow-thin.svg",
                                            alt: "dropdown button",
                                            className: "mr3",
                                            style: {
                                                width: 13,
                                                transform: "rotate(90deg)"
                                            }
                                        }),
                                        "Shop"
                                    ]
                                })
                            }),
                            (storeCollections === null || storeCollections === void 0 ? void 0 : storeCollections.length) ? renderCollectionList() : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallAppInstructionsOverlay, {}),
            showLogoutConfirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal["default"], {
                toggleLogoutModal: toggleLogoutModal,
                executeLogout: excuteLogout/* executeLogout */.q,
                showLogoutConfirmation: showLogoutConfirmation
            })
        ]
    });
};
/* harmony default export */ var Headers_CollectionHeaderDropdown = (CollectionHeaderDropdown);


/***/ }),

/***/ 29706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44541);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(92516);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(17321);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_Common_ReactHamburger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70440);
/* harmony import */ var _components_LoginAndDropdownComponent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29492);
/* harmony import */ var _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13508);
/* harmony import */ var _utils_getNavList__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4956);
/* harmony import */ var _utils_showMegaMenu__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36408);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86812);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66871);
/* harmony import */ var _CommonHeaderIcons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25823);
/* harmony import */ var _CollectionHeaderDropdown__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73838);
/* harmony import */ var _assets_svgExports_HeaderHome__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52882);
/* harmony import */ var _assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37247);
/* harmony import */ var _StoreNameComponent__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(44128);
/* harmony import */ var _ShopComponent__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(11525);
/* harmony import */ var _hooks_useSaveHeaderHeight__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(53395);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(13886);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26706);
/* harmony import */ var _components_MegaMenu_MegaMenuDesktopView__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(46065);

























var Header10 = function(props) {
    var ref, ref1, ref2;
    var isDesktop = _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_10__/* .deviceWidth */ .o > 786;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();
    var route = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        openShop: false,
        openMore: false,
        openDropdown: false
    }), open = ref4[0], setOpen = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        desktop: false,
        mobile: false
    }), openMegaMenu = ref5[0], setOpenMegaMenu = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), openCollections = ref6[0], setOpenCollections = ref6[1];
    var ref7 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_20__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            navigationList: state.additionalPagesReducer.navigationList,
            collections: state.catalogReducer.collections
        };
    }), storeData = ref7.storeData, navigationList = ref7.navigationList, collections = ref7.collections;
    var navItemsState = (0,_utils_getNavList__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(navigationList);
    var ref8 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            items: state.cartReducer.items,
            user: state.userReducer
        };
    }), items = ref8.items, user = ref8.user;
    var headerBgColor = (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.color_scheme) === null || ref1 === void 0 ? void 0 : ref1.bg_color) || "#FFFFFF";
    var headerRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();
    (0,_hooks_useSaveHeaderHeight__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(headerRef);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!open.openDropdown) setOpenCollections(false);
    }, [
        open.openDropdown
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !(navigationList === null || navigationList === void 0 ? void 0 : navigationList.length)) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_22__/* .getNavigationPagesList */ .A7)({
                storeId: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                isPublished: true
            }));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        navigationList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        if (isDesktop) {
            if (ref3.current && ref3.current.contains(e.target)) {
                return;
            }
            setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, state), {
                    openShop: false,
                    openMore: false
                });
            });
        }
    };
    var clickForRoute = function(route) {
        var ref;
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(route, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var handleCartClick = function() {
        if ((0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_11__/* .getStoreType */ .K)(storeData) === _utils_constants__WEBPACK_IMPORTED_MODULE_19__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_25__/* .toggleRfqFormModal */ .H4)());
            return;
        }
        clickForRoute(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.CART);
    };
    var menuItemClick = function(nav) {
        if ((openMegaMenu === null || openMegaMenu === void 0 ? void 0 : openMegaMenu.desktop) || (openMegaMenu === null || openMegaMenu === void 0 ? void 0 : openMegaMenu.mobile)) {
            setOpenMegaMenu(function() {
                return {
                    desktop: false,
                    mobile: false
                };
            });
        }
        if ((nav === null || nav === void 0 ? void 0 : nav.page_type) === "blank_page" && (nav === null || nav === void 0 ? void 0 : nav.is_external_url)) {
            window.open(nav.slug_url, "_blank");
            return;
        }
        if (nav.slug_url === "shop") {
            if (document.querySelector("#CollectionCategoryProductWidget")) {
                document.querySelector("#CollectionCategoryProductWidget").scrollIntoView();
            } else {
                var ref;
                next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
            }
        } else if (nav.slug_url === "subNavList") {
            setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, state), {
                    openMore: !open.openMore
                });
            });
        } else {
            if (nav.is_editable) {
                var ref1;
                window.location.href = (0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.additionalPage(nav.slug_url), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
            } else {
                var ref2;
                next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_3__.getRoute)(nav.slug_url, storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
            }
        }
    };
    var toggleDropdown = function() {
        setOpen(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, state), {
                openDropdown: !state.openDropdown
            });
        });
    };
    var routeMatchForActiveLink = function(url) {
        return "/[domain]".concat(url ? "/".concat(url) : "") === route.pathname ? "menu-item-active" : "";
    };
    var closeShopDropdown = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        return setOpen(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, state), {
                openShop: false,
                openDropdown: false
            });
        });
    }, []);
    var navSubList = function(nav) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "cfe-dropdown-nav",
            ref: ref3,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "cfe-dropdown-nav__items",
                children: nav.map(function(n) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "cfe-dropdown-nav__item",
                        onClick: function() {
                            return menuItemClick(n);
                        },
                        children: n.page_name
                    }, n.page_id);
                })
            })
        });
    };
    var handleShopClick = function(page, dropdownNav) {
        if ((0,_utils_showMegaMenu__WEBPACK_IMPORTED_MODULE_9__/* .showMegaMenu */ .G)()) {
            _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_7__/* .IS_DESKTOP */ .yn ? setOpenMegaMenu(function() {
                return {
                    mobile: false,
                    desktop: !openMegaMenu.desktop
                };
            }) : setOpenMegaMenu(function() {
                return {
                    desktop: false,
                    mobile: !openMegaMenu.mobile
                };
            });
        } else {
            if (collections === null || collections === void 0 ? void 0 : collections.length) {
                if (dropdownNav) {
                    setOpenCollections(true);
                } else {
                    menuItemClick(page);
                }
            } else {
                setOpen(function(state) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, state), {
                        openShop: true,
                        openMore: false
                    });
                });
            }
        }
    };
    var renderNavType = function(page) {
        var dropdownNav = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        switch(page.slug_url){
            case "":
                var ref, ref1;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item relative",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-between",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            style: {
                                flex: "1 1 auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mr3 visible-mobile",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_HeaderHome__WEBPACK_IMPORTED_MODULE_14__/* .HeaderHome */ .Q, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: page.page_name
                                })
                            ]
                        })
                    })
                }, page.page_id);
            case "shop":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ShopComponent__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    ref: ref3,
                    page: page,
                    dropdownNav: dropdownNav,
                    handleShopClick: handleShopClick,
                    setOpenMegaMenu: setOpenMegaMenu,
                    open: open,
                    closeShopDropdown: closeShopDropdown,
                    showMegaMenuMobile: openMegaMenu,
                    bgColor: headerBgColor
                });
            case "subNavList":
                var ref2;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "menu-item relative",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center",
                                    style: {
                                        flex: "1 1 auto"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "More"
                                    })
                                }),
                                (page === null || page === void 0 ? void 0 : (ref2 = page.subNavs) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                                    alt: "dropdown button",
                                    style: {
                                        transform: "rotate(90deg)",
                                        width: 7,
                                        marginLeft: dropdownNav ? "0px" : "8px"
                                    }
                                })
                            ]
                        }),
                        open.openMore && navSubList(page.subNavs)
                    ]
                }, page.page_id);
            case "about-us":
                var ref4, ref5;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item relative",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-between",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            style: {
                                flex: "1 1 auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mr3 visible-mobile",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_15__/* .HeaderInfoIcon */ .V, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.theme) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.colors) === null || ref5 === void 0 ? void 0 : ref5.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: page.page_name
                                })
                            ]
                        })
                    })
                }, page.page_id);
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item ".concat(routeMatchForActiveLink(page.slug_url)),
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: page.page_name
                }, page.page_id);
        }
    };
    var searchBar = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "search-comp flex items-center justify-center pointer w-100",
            onClick: function() {
                return clickForRoute(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.SEARCH);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/nmNB3Y56.webp",
                    className: "mr2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "ttu",
                    children: "Search"
                })
            ]
        });
    };
    var leftSection = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "visible-desktop-flex items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StoreNameComponent__WEBPACK_IMPORTED_MODULE_16__/* .StoreNameComp */ ._, {
                        showLogo: true
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "visible-mobile-flex w-100",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_ReactHamburger__WEBPACK_IMPORTED_MODULE_5__["default"], {
                        open: open.openDropdown,
                        setOpen: toggleDropdown,
                        theme: "#000000"
                    })
                })
            ]
        });
    };
    var middleSection = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "visible-desktop-flex",
            children: searchBar()
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        ref: headerRef,
        className: "header10 collection-header",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "header10__top-component",
                children: [
                    leftSection(),
                    middleSection(),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "flex items-center justify-end icon-set visible-desktop",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_LoginAndDropdownComponent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: "icon-set-image",
                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/SPz76B8j.webp"
                                        }),
                                        (user === null || user === void 0 ? void 0 : user.isLogin) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            alt: "dropdown button",
                                            src: "/assets/images/down-arrow-thin.svg",
                                            className: "ml2 arrow-icon"
                                        }) : ""
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                onClick: handleCartClick,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "icon-set-image",
                                        src: "https://cdn.dotpe.in/longtail/themes/8073865/knl2aF18.webp"
                                    }),
                                    (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "cart-items absolute z-2",
                                        children: items.length
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "visible-mobile",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommonHeaderIcons__WEBPACK_IMPORTED_MODULE_12__/* .CommonHeaderIconsMobile */ .r, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "header10__bottom-component w-100 visible-desktop",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "visible-desktop-flex w-100 justify-center",
                    children: (navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "header10__bottom-component--menu",
                        children: navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.map(function(nav) {
                            return renderNavType(nav, true);
                        })
                    })
                })
            }),
            openMegaMenu.desktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MegaMenu_MegaMenuDesktopView__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                open: openMegaMenu.desktop,
                onClose: function() {
                    return setOpenMegaMenu({
                        desktop: false,
                        mobile: false
                    });
                }
            }),
            open.openDropdown && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionHeaderDropdown__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                renderNavType: renderNavType,
                navItemsState: navItemsState,
                openCollections: openCollections,
                goBack: function() {
                    return setOpenCollections(false);
                },
                collectionListType: (props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : ref2.name) || null
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Header10);


/***/ }),

/***/ 46065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MegaMenu_MegaMenuDesktopView; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/MegaMenu/megaMenu.module.scss
var megaMenu_module = __webpack_require__(98224);
var megaMenu_module_default = /*#__PURE__*/__webpack_require__.n(megaMenu_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/MegaMenu/svgIcons.js
var svgIcons = __webpack_require__(20941);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
;// CONCATENATED MODULE: ./src/components/MegaMenu/RenderCategory.js







var RenderCategory = function(props) {
    var splitObjectsIntoGroups = function splitObjectsIntoGroups(objects, batchSize) {
        var result = [];
        for(var i = 0; i < objects.length; i += batchSize){
            var batch = objects.slice(i, i + batchSize);
            result.push(batch);
        }
        return result;
    };
    var categories = props.categories, onClose = props.onClose, collectionId = props.collectionId;
    var ref = (0,react.useState)([]), currCategories = ref[0], setCurrCategories = ref[1];
    var ref1 = (0,react.useState)({
        more: false,
        less: false
    }), showMoreLess = ref1[0], setShowMoreLess = ref1[1];
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    (0,react.useEffect)(function() {
        if (categories.length < 36) {
            setCurrCategories(categories);
        } else if (categories.length >= 36) {
            setShowMoreLess({
                more: true,
                less: false
            });
            setCurrCategories(categories.slice(0, 36));
        }
    }, [
        categories
    ]);
    (0,react.useEffect)(function() {
        if (showMoreLess.more) {
            setCurrCategories(categories.slice(0, 36));
        } else {
            setCurrCategories(categories);
        }
    }, [
        showMoreLess
    ]);
    var totalCategories = currCategories === null || currCategories === void 0 ? void 0 : currCategories.length;
    var maxCols = Math.min(6, Math.ceil(totalCategories / 6));
    var maxRows = Math.max(6, Math.ceil(totalCategories / maxCols));
    var handleCategoryClick = function(category) {
        var ref;
        if (category.isMoreLess) return;
        router_default().push((0,routes.getRoute)("".concat(routes.PATH.collectionCategories(collectionId), "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain), undefined, {
            shallow: true,
            scroll: true
        });
        onClose && onClose();
    };
    var displayMoreLess = function(type) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex",
            style: {
                gap: "2px",
                alignItems: "center",
                cursor: "pointer"
            },
            onClick: handleMoreLessClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "#000"
                    },
                    children: type
                }),
                showMoreLess.more ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* MoreCarat */.MK, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* LessCarat */.gO, {})
            ]
        });
    };
    var handleMoreLessClick = function() {
        if (showMoreLess.more) {
            setShowMoreLess({
                more: false,
                less: true
            });
        } else {
            setShowMoreLess({
                more: true,
                less: false
            });
        }
    };
    var splittedCategories = splitObjectsIntoGroups(currCategories, maxRows);
    if (currCategories.length >= 36) {
        var ref2;
        (ref2 = splittedCategories[maxCols - 1]) === null || ref2 === void 0 ? void 0 : ref2.push({
            isMoreLess: true,
            type: showMoreLess.more ? "More" : "Less"
        });
    }
    var categoriesGrid = [];
    for(var row = 0; row < maxRows; row++){
        categoriesGrid.push([]);
        for(var col = 0; col < maxCols; col++){
            var index = row + col * maxRows;
            if (index < totalCategories) {
                categoriesGrid[row].push(currCategories[index]);
            } else {
                categoriesGrid[row].push(null); // Add a placeholder for empty cells
            }
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (megaMenu_module_default()).categoriesWrapper,
        style: {
            width: "700px",
            gap: "24px"
        },
        children: splittedCategories.map(function(col, colIndex) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (megaMenu_module_default()).categoryColumn,
                children: col.map(function(category, rowIndex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (megaMenu_module_default()).categoryItem,
                        onClick: function() {
                            return handleCategoryClick(category);
                        },
                        children: category.isMoreLess && categories.length > 36 ? displayMoreLess(category.type) : category.name
                    }, colIndex);
                })
            }, colIndex);
        })
    });
};
/* harmony default export */ var MegaMenu_RenderCategory = (RenderCategory);

// EXTERNAL MODULE: ./src/utils/routeToCollectionPage.js
var routeToCollectionPage = __webpack_require__(85618);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
;// CONCATENATED MODULE: ./src/components/MegaMenu/MegaMenuDesktopView.js








var MEGA_MENU_BACKDROP = "MEGA_MENU_BACKDROP";
var MegaMenuDesktopView = function(param) {
    var open = param.open, onClose = param.onClose;
    var collections = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections
        };
    }).collections;
    var ref = (0,react.useState)(null), highlightedCollectionId = ref[0], setHighlightedCollectionId = ref[1];
    (0,react.useEffect)(function() {
        if (open) {
            document.body.classList.add("tw-overflow-y-hidden");
        } else {
            document.body.classList.remove("tw-overflow-y-hidden");
        }
        return function() {
            document.body.classList.remove("tw-overflow-y-hidden");
        };
    }, [
        open
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (highlightedCollectionId && collections.length > 2 && (highlightedCollectionId === ((ref = collections[collections.length - 2]) === null || ref === void 0 ? void 0 : ref.id) || highlightedCollectionId === ((ref1 = collections[0]) === null || ref1 === void 0 ? void 0 : ref1.id))) {
            var currentCollection = document.getElementById("panel-collection-id-".concat(highlightedCollectionId));
            if (currentCollection) {
                var dialogRect = currentCollection.parentElement.getBoundingClientRect();
                var elementRect = currentCollection.getBoundingClientRect();
                // Calculate the offset from the top of the dialog to the top of the element
                var offset = elementRect.top - dialogRect.top - 34;
                // Scroll the dialog by the calculated offset
                currentCollection.parentElement.scrollTo({
                    top: currentCollection.parentElement.scrollTop + offset,
                    behavior: "smooth"
                });
            }
        }
    }, [
        highlightedCollectionId
    ]);
    (0,react.useEffect)(function() {
        var handleIntersection = function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var collectionId = parseInt(entry.target.dataset.collectionId);
                    setHighlightedCollectionId(collectionId);
                }
            });
        };
        var observer = new IntersectionObserver(handleIntersection, {
            root: document.getElementById("collection-in-view"),
            rootMargin: "0px 0px -350px 0px",
            threshold: 0.25
        });
        var collectionContentNodes = document.querySelectorAll("[data-collection-id]");
        collectionContentNodes.forEach(function(node) {
            return observer.observe(node);
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        open
    ]);
    var handleLeftPanelCollectionClick = function(e, collectionId) {
        e.stopPropagation();
        var collectionContent = document.getElementById("collection-".concat(collectionId));
        if (collectionContent) {
            var dialogRect = collectionContent.parentElement.getBoundingClientRect();
            var elementRect = collectionContent.getBoundingClientRect();
            // Calculate the offset from the top of the dialog to the top of the element
            var offset = elementRect.top - dialogRect.top - 16;
            // Scroll the dialog by the calculated offset
            collectionContent.parentElement.scrollTo({
                top: collectionContent.parentElement.scrollTop + offset,
                behavior: "smooth"
            });
        }
    };
    var renderCollectionNameList = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (megaMenu_module_default()).collectionListWrapper,
            children: collections.map(function(collection) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((megaMenu_module_default()).collectionNameMenu, collection.id === highlightedCollectionId ? (megaMenu_module_default()).highlighted : ""),
                    id: "panel-collection-id-".concat(collection.id),
                    onClick: function(e) {
                        return handleLeftPanelCollectionClick(e, collection.id);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (megaMenu_module_default()).collectionName,
                            children: collection.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (megaMenu_module_default()).leftCaratIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* LeftCaratIcon */.vT, {})
                        })
                    ]
                }, collection.id);
            })
        });
    };
    var renderCollectionCategories = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (megaMenu_module_default()).collectionContentWrapper,
            id: "collection-in-view",
            children: collections.map(function(collection) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (megaMenu_module_default()).collectionContent,
                    id: "collection-".concat(collection.id),
                    "data-collection-id": collection.id,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (megaMenu_module_default()).collectionImage,
                            children: collection.image_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: collection.image_url
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* CollectionWithNoImage */.p3, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (megaMenu_module_default()).categoriesDisplay,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (megaMenu_module_default()).collectionName,
                                    onClick: function() {
                                        (0,routeToCollectionPage/* routeToCollectionPage */.L)(collection);
                                        onClose();
                                    },
                                    children: collection.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_RenderCategory, {
                                    collectionId: collection.id,
                                    categories: collection.categories,
                                    onClose: onClose
                                })
                            ]
                        })
                    ]
                }, collection.id);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((megaMenu_module_default()).desktopView, open ? (megaMenu_module_default()).open : ""),
        id: MEGA_MENU_BACKDROP,
        onClick: function(e) {
            var ref;
            if (((ref = e.target) === null || ref === void 0 ? void 0 : ref.id) === MEGA_MENU_BACKDROP) {
                e.stopPropagation();
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.04)",
                        width: "100%",
                        position: "relative",
                        top: "0",
                        height: "8px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        width: "100%",
                        height: "500px",
                        background: "#fff",
                        display: "flex"
                    },
                    children: [
                        renderCollectionNameList(),
                        renderCollectionCategories()
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var MegaMenu_MegaMenuDesktopView = (MegaMenuDesktopView);


/***/ }),

/***/ 93326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6337);

var checkIfWebview = function() {
    return !_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6 && !!window.ReactNativeWebView;
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfWebview);


/***/ })

}]);